<template>
    <div class="container-fluid">

        <ul class="nav nav-pills" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
                <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Resultados</a>
            </li>
            <li class="nav-item" role="presentation" v-if="consultas && consultas.length">
                <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Consultas</a>
            </li>
        </ul>
            
        <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">

                <az-empty-state class="mt-3" v-if="!lista.length && !( legado && legado.length )" msg="Nenhum Resultado Disponível." />

                <!-- Lista de Laudos -->

                <div class="mt-3" id="lista-de-trabalho" v-else>

                    <div class="mb-3" v-if="msg_resultado">
                        <div v-html="msg_resultado"></div>
                    </div>

                    <div class="alert alert-danger d-flex justify-content-between" v-if="pagpend">
                        <div style="white-space: pre-wrap;">{{ pagpend }}</div>
                        <div>
                            <i class="fa-solid fa-triangle-exclamation"></i>
                        </div>
                    </div>

                    <div v-else-if="nps_avaliar" class="alert alert-info d-flex justify-content-between">
                        <span v-if="nps_avaliar.nps_texto_html" v-html="nps_avaliar.nps_texto"></span>
                        <span v-else style="white-space: pre-wrap;">{{ nps_avaliar.nps_texto }}</span>
                        <div>
                            <a :href="nps_avaliar.link" target="_blank" class="btn btn-info">
                                Avaliar Atendimento
                            </a>
                        </div>
                    </div>

                    <div class="mb-3 mx-3">

                        <div v-for="(items, quebra, iqx) in lista_agrupada" :key="'L-' + quebra + ( iqx ? iqx : '' )" class="row my-2 py-1 dashcard w3-animate-opacity bg-white">
                            <div class="col col-12">
                                <div class="row align-items-center">
                                    <!-- Data -->
                                    <div class="col col-12 col-md-4"> 
                                        <div>{{ $util.getFormatDate(items[0].dt_inclusao) }} {{ items[0].dt_inclusao.substr(11,5) }}</div>
                                        <div>#{{ items[0].atendimento_procedimento.id_atendimento }}</div>
                                    </div>
                                    
                                    <div class="col col-12 col-md-4 d-flex justify-content-between" v-if="items.length == 1 && !is_lab(items[0])">
                                        <celula-dados-procedimento :hor="dados_procedimento(items[0])" :blockanexos="true" />
                                    </div>

                                    <div class="col col-12 col-md-4" v-else>
                                        <div class="small text-muted">Prazo Final: {{ $util.getFormatDate(prazo(items)) }}</div>
                                        <a href="#" @click.prevent="items[0].exibir_detalhes = !items[0].exibir_detalhes" class="mr-1">
                                            <i class="fa-regular fa-square-plus" v-if="!items[0].exibir_detalhes"></i>
                                            <i class="fa-regular fa-square-minus" v-else></i>
                                        </a>
                                        <span class="badge badge-secondary mr-1" data-toggle="tooltip" data-placement="top" title="Prontos vs Total">
                                            {{ items.filter(item => item.status_laudo && item.status_laudo.fl_pronto).length }}/{{ items.length }}
                                        </span>
                                        <span v-for="(item, iix) in items" :key="iix">
                                            <span class="badge mr-1" :class="'badge-' + cor_pilula_item(item)"
                                                data-toggle="tooltip" data-placement="top" :title="item.status_laudo.search"
                                                v-if="!items[0].primeiros || iix < limite">
                                                {{ sigla(item) }}
                                            </span>
                                        </span>
                                        <a href="#" @click.prevent="items[0].primeiros = !items[0].primeiros" v-if="items.length > limite && ( items[0].primeiros === true || items[0].primeiros === false )" >
                                            <span class="badge badge-pill badge-secondary">
                                                <i class="fa-solid fa-ellipsis" v-if="items[0].primeiros"></i>
                                                <i class="fa-solid fa-arrow-left" v-else></i>
                                            </span>
                                        </a>
                                    </div>

                                    <!-- Impressão -->
                                    <div class="col col-12 col-md-4 text-right">

                                        <template v-if="!sem_imagens && items && items[0] && items[0].atendimento_procedimento && items[0].atendimento_procedimento.st_pacs == 'OK'">
                                            <button type="button" class="btn btn-dark mr-1" 
                                                @click="open_url_estudo(items[0].atendimento_procedimento)"
                                                :disabled="$store.state.loading">
                                                Imagens
                                            </button>
                                        </template>

                                        <template v-if="teste_pagend(items[0])">
                                            <button type="button" class="btn btn-primary" disabled>
                                                Laudo
                                            </button>
                                        </template>

                                        <template v-else-if="items.length == 1 && !is_lab(items[0])">

                                            <span v-if="items[0].status_laudo && !items[0].status_laudo.fl_pronto && items[0].atendimento_procedimento.procedimento.id_especialidade != 2 && items[0].atendimento_procedimento.dt_entrega"
                                                class="badge badge-success">
                                                Prazo: {{ $util.getFormatDate(items[0].atendimento_procedimento.dt_entrega) }}
                                            </span>

                                            <template v-else>

                                                <template v-if="!( items[0].arquivos && items[0].arquivos.filter(arq => arq.st_tipo_especial != 'anexo').length )">
                                                    <a :href="items[0].doc_certificado_link" target="_blank" class="btn btn-primary" :disabled="!items[0].status_laudo || !items[0].status_laudo.fl_pronto" 
                                                        v-if="$store.state.user.st_tipo != 'P' && items[0].doc_certificado_link" title="1">
                                                        Laudo
                                                    </a>
                                                    <button type="button" class="btn btn-primary" title="2" :disabled="!items[0].status_laudo || !items[0].status_laudo.fl_pronto" @click="imprimir(items[0])" v-else>
                                                        Laudo
                                                    </button>
                                                </template>
                                                <template v-if="items[0].arquivos && items[0].arquivos.length && items[0].status_laudo && items[0].status_laudo.fl_pronto">
                                                    <button type="button" class="btn ml-1" v-for="(arq, iax) in items[0].arquivos" :key="iax" @click="abrir_laudo_link(items[0], arq.arquivo.temporary_url)" title="3" :class="arq.st_tipo_especial == 'anexo' ? 'btn-secondary' : 'btn-primary'" :disabled="!items[0].status_laudo || !items[0].status_laudo.fl_pronto">
                                                        {{ arq.st_tipo_especial == 'anexo' ? 'Anexo' : 'Laudo' }} 
                                                    </button>
                                                    <template v-if="false">
                                                        <a :href="arq.arquivo.temporary_url" target="_blank" class="btn ml-1" title="3" :class="arq.st_tipo_especial == 'anexo' ? 'btn-secondary' : 'btn-primary'" :disabled="!items[0].status_laudo || !items[0].status_laudo.fl_pronto" 
                                                            v-for="(arq, iax) in items[0].arquivos" :key="iax">
                                                            {{ arq.st_tipo_especial == 'anexo' ? 'Anexo' : 'Laudo' }}
                                                        </a>
                                                    </template>
                                                </template>

                                            </template>

                                        </template>
                                        
                                        <template v-else-if="get_item_link(items)">
                                            <button type="button" class="btn btn-primary" title="4" v-if="$store.state.user.st_tipo != 'R' && lista_medicos(items[0]) && lista_medicos(items[0]).length > 1" @click="selecionar_medico(get_item_link(items))">
                                                Laudo
                                            </button>

                                            <button type="button" class="btn btn-primary" title="4" v-else @click="abrir_laudo_link(get_item_link(items))">
                                                Laudo
                                            </button>
                                        </template>

                                        <template v-else-if="items.length > 0 && items[0].atendimento_procedimento.procedimento.id_especialidade == 2">
                                            <button type="button" class="btn btn-primary" title="Imprimir (1)" :disabled="!tem_laudo_pronto(items)" @click="imprimir_lab(items[0])">
                                                Laudo
                                            </button> 
                                        </template>

                                        <template v-else>
                                            <span v-if="items[0].atendimento_procedimento.procedimento.id_especialidade != 2 && items[0].atendimento_procedimento.dt_entrega">
                                                Prazo: {{ $util.getFormatDate(items[0].atendimento_procedimento.dt_entrega) }}
                                            </span>
                                            <button class="btn btn-primary" title="7" disabled v-else>
                                                Laudo
                                            </button>
                                        </template>

                                        <template
                                            v-if="podeCompartilhar(items)">
                                            <button type="button" class="btn btn-outline-success ml-1"
                                                @click="compartilhar(items)"
                                                title="Compartilhar Resultado"
                                                :disabled="$store.state.loading">
                                                <i class="fa-solid fa-share"></i>
                                            </button>
                                        </template>

                                        <template v-if="items[0].atendimento_procedimento.procedimento.id_especialidade == 2 && $store.state.user.st_tipo == 'O'">
                                            <button type="button" class="btn btn-outline-dark ml-2" @click="imprimir_etiqueta([items[0]])" title="Imprimir Etiquetas" data-toggle="tooltip">
                                                <i class="fa-solid fa-barcode"></i>
                                            </button>
                                        </template>

                                        
                                    </div>
                                </div>
                                <template v-if="items && items[0] && items[0].exibir_detalhes">
                                    <div class="row mt-3" v-if="$store.state.user.st_tipo != 'R' && items[0].atendimento_procedimento.atendimento.id_medico_solicitante">
                                        <div class="col col-12">
                                            <az-input 
                                                label="Solicitante"
                                                :compact="true"
                                                sizing="sm"
                                                placeholder="Profissional Solicitante..."
                                                type="select"
                                                :optionsList="lista_medicos(items[0])"
                                                optionsData="id_medico_solicitante"
                                                v-model="items[0].atendimento_procedimento.atendimento.id_medico_solicitante" />
                                        </div>
                                    </div>
                                    <div class="row" >
                                        <div class="col col-12">
                                            <table class="table table-sm table-hover mt-3 mb-3">
                                                <thead>
                                                    <tr>
                                                        <th class="d-none d-md-block">Código</th>
                                                        <th>Exame</th>
                                                        <th>Status</th>
                                                        <th class="d-none d-md-block">Prazo</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(laudo, ilx) in items" :key="ilx" :class="nao_solicitado(laudo, items[0].atendimento_procedimento.atendimento.id_medico_solicitante) ? 'table-secondary text-muted' : ''">
                                                        <td class="d-none d-md-block">
                                                            <span class="badge" :class="'badge-' + cor_pilula_item(laudo)">
                                                                {{ sigla(laudo) }}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            {{ laudo.atendimento_procedimento.procedimento.search }}
                                                        </td>
                                                        <td>
                                                            <span v-if="laudo.emitido && laudo.emitido_info" class="badge" :class="'badge-' + laudo.emitido_info.cor">
                                                                {{ laudo.emitido_info.titulo }}
                                                            </span>
                                                            <span class="badge" :class="'badge-' + laudo.status_laudo.st_color" v-else>
                                                                {{ laudo.status_laudo.search }}
                                                            </span>

                                                            <span v-if="laudo.etapa_klis" class="badge badge-light ml-2">
                                                                {{ laudo.etapa_klis }}
                                                            </span>
                                                        </td>
                                                        <td class="d-none d-md-block">
                                                            <span v-if="!laudo.status_laudo.fl_nao_coletar && laudo.status_laudo.st_acao_especial != 'N' && laudo.atendimento_procedimento.dt_entrega">
                                                                {{ $util.getFormatDate(laudo.atendimento_procedimento.dt_entrega) }}
                                                            </span>
                                                            <span v-else-if="laudo.motivo_recoleta" class="small">
                                                                {{ laudo.motivo_recoleta }}
                                                            </span>
                                                            <span v-else>&nbsp;</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <pre v-if="false">{{ items }}</pre>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <!-- Legado -->
                        <template v-if="legado && legado.length">
                            <div v-for="(iteml, ilx) in legado" :key="'LG-' + ilx" class="row my-2 py-1 dashcard w3-animate-opacity bg-white">
                                <div class="col col-12">
                                    <div class="row align-items-center">
                                        <!-- Data -->
                                        <div class="col col-12 col-md-4"> 
                                            <div>{{ $util.getFormatDate(iteml.dt_data) }}</div>
                                        </div>
                                        
                                        <div class="col col-12 col-md-4">
                                            <div>{{ iteml.st_descricao }}</div>
                                            <div class="small text-muted">{{ iteml.st_nome_medico }}</div>
                                        </div>

                                        <!-- Impressão -->
                                        <div class="col col-12 col-md-4 text-right">

                                            <template v-if="iteml && iteml.st_an">
                                                <button type="button" class="btn btn-dark mr-1" 
                                                    @click="open_url_estudo_legado(iteml)"
                                                    :disabled="$store.state.loading">
                                                    Imagens
                                                </button>
                                            </template>

                                            <template v-if="iteml.arquivos && iteml.arquivos.length">
                                                <a :href="arquivo.arquivo.temporary_url" target="_blank" class="btn btn-primary ml-1" v-for="(arquivo, iax) in iteml.arquivos" :key="iax">
                                                    Laudo
                                                </a>
                                            </template>

                                            <template v-else-if="limp">
                                                <a href="#" @click.prevent="imprimir_legado(iteml)" class="btn btn-primary ml-1">
                                                    Laudo
                                                </a>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>

                    </div>
                </div>

                <pre v-if="false">{{ lista_agrupada }}</pre>

            </div>

            <!-- Consultas -->
            <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                <!-- Lista de Laudos -->

                <div class="mt-3" id="lista-de-trabalho" v-if="consultas && consultas.length">
                    <div class="mb-3 mx-3">
                        <div class="row my-2 py-1 dashcard align-items-center w3-animate-opacity bg-white" v-for="(item, index) in consultas" :key="index">
                            <!-- Data -->
                            <div class="col col-12 col-md-4"> 
                                <div>{{ $util.getFormatDate(item.dt_inicio) }} {{ item.dt_inicio.substr(11,5) }}</div>
                                <div>#{{ item.id_atendimento }}</div>
                            </div>
                            
                            <div class="col col-12 col-md-4 d-flex justify-content-between">
                                <celula-dados-procedimento :hor="{ marcacao: item }" :blockanexos="true" />
                                <!-- @abriranexos="abrir_anexar_arquivo" @abrirpreatend="$refs.doc_pre_atend.abrir" /> -->
                            </div>

                            <!-- Impressão -->
                            <div class="col col-12 col-md-4 text-right">
                                <template v-for="(atp, iax) in item.atendimento_procedimentos">
                                    <template v-if="atp.anamnese">
                                        <template v-for="(rec, irx) in atp.anamnese.receita">
                                            <a :href="rec.doc_certificado_link" class="btn btn-sm btn-outline-success ml-1 mb-1" :key="'REC' + iax + '.' + irx" v-show="rec.doc_certificado_link" target="_blank" v-if="true">
                                                Receita
                                            </a>
                                        </template>

                                        <template v-for="(req, iqx) in atp.anamnese.requisicao">
                                            <a :href="req.doc_certificado_link" class="btn btn-sm btn-outline-success ml-1 mb-1" :key="'REQ' + iax + '.' + iqx" v-show="req.doc_certificado_link" target="_blank" v-if="true">
                                                Requisição
                                            </a>
                                        </template>

                                        <template v-for="(ate, itx) in atp.anamnese.atestados">
                                            <a :href="ate.doc_certificado_link" class="btn btn-sm btn-outline-success ml-1 mb-1" :key="'ATE' + iax + '.' + itx" v-show="ate.doc_certificado_link" target="_blank" v-if="true">
                                                Atestado
                                            </a>
                                        </template>

                                        <template v-for="(doc, idx) in atp.anamnese.documentos">
                                            <a :href="doc.doc_certificado_link" class="btn btn-sm btn-outline-success ml-1 mb-1" :key="'DOC' + iax + '.' + idx" v-show="doc.doc_certificado_link" target="_blank" v-if="true">
                                                {{ doc.st_titulo ? doc.st_titulo : 'Documento' }}
                                            </a>
                                        </template>
                                    </template>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        
        <!-- Modal -->
        <div class="modal fade" id="selecaoSolicitanteModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Selecionar Solicitante</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="item_pra_selecao">
                            <div class="alert alert-info">
                                Clique no nome do solicitante para acessar o laudo.
                            </div>

                            <div class="list-group">
                                <a :href="tratar_link(item_pra_selecao.link, item_pra_selecao, medico.id_medico_solicitante)" 
                                    class="list-group-item list-group-item-action" 
                                    v-for="(medico, imx) in lista_medicos(item_pra_selecao)" 
                                    :key="imx"
                                    target="_blank">
                                    {{ medico.search }}
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="compartilharResultadosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Compartilhar</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="d-flex flex-column">
                            <div class="mb-2">
                                <az-input
                                    type="email"
                                    icon="far fa-envelope fa-fw"
                                    placeholder="Não informado"
                                    v-model="email_compartilhar" />
                                <az-input
                                    type="fone"
                                    icon="fa fa-mobile fa-fw"
                                    placeholder="Não informado"
                                    :edicao2="false"
                                    v-model="telefone_compartilhar" />
                            </div>

                            <div class="d-flex flex-column mb-3">
                                <button type="button" class="btn btn-outline-primary" @click="compartilhar_email()">
                                    <i class="far fa-envelope mr-2"></i>
                                    Email
                                </button>
                                <button type="button" class="btn btn-outline-success mt-2" @click="compartilhar_whatsapp()">
                                    <i class="fa fa-whatsapp mr-2" aria-hidden="true"></i>
                                    WhatsApp
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <modelo-impressao />        
    </div>    
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzEmptyState from '../util/AzEmptyState.vue';
import CelulaDadosProcedimento from '../shared/table/CelulaDadosProcedimento.vue';
import ModeloImpressao from '../relatorios/impressao/ModeloImpressao.vue';
import AzInput from '../shared/forms/AzInput.vue';

export default {
    data() { 
        return { 
            laudos: null, 
            consultas: null, 
            limite: 15,
            nps_avaliar: null,
            pagpend: "", 
            pagpend_lista: null,
            item_pra_selecao: null, 
            legado: null, 
            portal_resultados_abertos: false,
            sem_imagens: false,
            limp: false,
            email_compartilhar: "",
            telefone_compartilhar: "",
            links_compartilhar: [],
            msg_resultado: "", 
        }
    },

    props: ['id_paciente', 'timbrado'], 

    computed: { 
        lista: function () { 
            if ( !this.laudos )
                return [];

            return this.laudos.filter(laudo => !laudo.excluido)
                .filter(item => item.status_laudo 
                    && ( item.status_laudo.fl_pronto || 
                    ( this.portal_resultados_abertos ) || 
                    ( item.atendimento_procedimento && item.atendimento_procedimento.procedimento && item.atendimento_procedimento.procedimento.id_especialidade == 2 ) )
                );
        },

        lista_agrupada: function () { 
            if ( !this.lista || !this.lista.length ) {
                return [];
            }

            return _.orderBy(
                    _.groupBy(this.lista, (item) => {
                        return this.is_lab(item) 
                            ? 'L' + item.atendimento_procedimento.id_atendimento 
                            : item.atendimento_procedimento.id_atendimento_procedimento;
                    }),
                    '0.dt_inclusao', 
                    'desc'
                );
        },
    },

    components: { 
        CelulaDadosProcedimento,
        AzEmptyState, 
        ModeloImpressao,
        AzInput, 
    },

    methods: { 
        podeCompartilhar(items) {
            // return items && items[0] && items[0].atendimento_procedimento && items[0].atendimento_procedimento.st_pacs == 'OK';
            return items[0].doc_certificado_link;
        },

        compartilhar(items) {
            this.links_compartilhar = [];

            this.$util.atualizar(this, {
                service: 'laudos',
                func: 'compartilhar_link_portal',
                dados: {
                    id_laudo: items[0].id_laudo,
                },
                callback: res => {
                    console.log('compartilhar_link_portal', res);

                    if ( items[0].doc_certificado_link ) {
                        this.links_compartilhar.push({
                            'Título': 'Laudo:',
                            url: items[0].doc_certificado_link,
                        });
                    }

                    if ( res && Array.isArray(res.links) ) {
                        this.links_compartilhar = this.links_compartilhar.concat(res.links);
                    }

                    if ( this.links_compartilhar.length ) {
                        $('#compartilharResultadosModal').modal('show');
                    }
                }
            });
        },

        compartilhar_email() {
            const email = this.email_compartilhar && this.email_compartilhar.trim();

            if ( !email ) {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'E-mail não informado',
                    detail: 'Informe um e-mail para compartilhar os resultados.',
                    life: 3000,
                });
                return;
            }

            const assunto = 'Resultados de exames';
            const mensagem = this.mensagem_compartilhar();
            const url = `mailto:${encodeURIComponent(email)}?subject=${encodeURIComponent(assunto)}&body=${encodeURIComponent(mensagem)}`;

            window.open(url, '_blank');
        },

        compartilhar_whatsapp() {
            const mensagem = this.mensagem_compartilhar();
            const texto = encodeURIComponent(mensagem);
            let celular = this.telefone_compartilhar ? this.telefone_compartilhar.replace(/\D/g, '') : '';

            if ( celular ) {
                if ( !celular.startsWith('55') ) {
                    celular = '55' + celular;
                }

                window.open(`https://wa.me/${celular}?text=${texto}`, '_blank');
            } else {
                window.open(`whatsapp://send?text=${texto}`, '_blank');
            }
        },

        mensagem_compartilhar() {
            const links = this.links_compartilhar
                .filter(link => link && link.url)
                .map(link => `${link['Título'] ? link['Título'] + ' ' : ''}${link.url}`)
                .join('\n\n');

            return `Aqui estão os links para acessar os resultados:\n\n${links}`;
        },

        imprimir_legado(item) { 
            this.$util.print_preview('imprimir/legado/' + item.id_prontuario_legado, true);
        },

        get_item_link(lista) { 
            return lista.find(item => item.link);
        },
        
        abrir_laudo_link (laudo, link = null) { 

            const win = window.open('', '_blank');

            if ( this.$store.state.user.st_tipo == 'P' ) { 
                this.$util.atualizar(this, { 
                    service: 'laudos', 
                    func: 'entregar', 
                    dados: { 
                        id_laudo: laudo.id_laudo, 
                        entregar_para: 'Paciente pelo Portal',
                        local: 'portal',
                    },
                    callback: res => { 
                        console.log('entregar', res);

                        if ( res === null ) { 
                            win.close();
                            return; 
                        }

                        win.location = link ? link : this.tratar_link(laudo.link, laudo);
                    }
                });
            } else { 
                win.location = link ? link : this.tratar_link(laudo.link, laudo);
                //window.open(link ? link : this.tratar_link(laudo.link, laudo), '_blank');
            }                                   

        },

        teste_pagend (laudo) { 

            if ( !this.pagpend ) { 
                return false;
            }

            if ( !this.pagpend_lista || !this.pagpend_lista.length ) { 
                return false; 
            }

            return this.pagpend_lista.findIndex(item => item == laudo.atendimento_procedimento.id_atendimento) >= 0 ? true : false;

        },

        cor_pilula_item(laudo) { 
            if ( laudo.emitido && laudo.emitido_info && laudo.emitido_info.cor ) 
                return laudo.emitido_info.cor;

            if ( laudo.status_laudo && laudo.status_laudo.st_color ) { 
                return laudo.status_laudo.st_color;
            }

            return 'secondary';
        },

        imprimir_etiquetas () { 
            let lista = _.map(
                this.lista_agrupada,
                items => { 
                    return { 
                        id_atendimento: items[0].atendimento_procedimento.atendimento.id_atendimento
                    }
                }
            );

            console.log('lista', lista);
        },

        imprimir_etiqueta (lista) { 
            if ( !confirm('Deseja imprimir etiquetas para os exames selecionados?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'apoiados',
                func: 'etiquetas', 
                dados: { 
                    lista: lista.map(item => { 
                        return { 
                            id_atendimento: item.atendimento_procedimento.atendimento.id_atendimento
                        }
                    }), 
                },
            });
        },

        selecionar_medico (item) { 
            this.item_pra_selecao = item;

            $('#selecaoSolicitanteModal').modal('show');
        },

        open_url_estudo_legado(item) {
            if (!item || !item.st_an ) return;

            this.$util.load(this, {
              service: 'pep',
              func: 'dr_tis_url',
              redir_api: true,
              parms: {
                accession_number: item.st_an
              },
              loadTo: (res) => {
                if (res && res.url) {
                  window.open(res.url, '_blank').focus();
                }
              }
            });
        },

        open_url_estudo(item) {
            this.$util.load(this, {
                service: 'pep',
                func: 'dr_tis_url',
                redir_api: true,
                parms: {
                    id_atendimento_procedimento: item.id_atendimento_procedimento,
                    id_paciente: item.atendimento.id_paciente,
                    toast: true,
                    is_portal: true
                },
                loadTo: (res) => {
                    if(res && res.url) {
                        this.$util.pacs_open_window(res.url);
                    } else { // if(!toast) {
                        if(res && res.msg) {
                            this.$toast.add({
                                severity: "error",
                                summary: "Atenção",
                                detail: res.msg,
                                life: 3000
                            });
                        } else {
                            let params = 'msg=Estudo não disponível no PACS: #' + item.id_atendimento + ' / ' + item.st_an;
                            params = new URLSearchParams(params).toString();
                            this.$util.pacs_open_window_default(params);
                        }
                    }
                }
            });
        },

        tratar_link (link, laudo, id_medico_solicitante = null) { 
            if ( laudo 
                && ['terceiroFleury'].includes(_.get(laudo, 'atendimento_procedimento.amostra_atendimento_procedimento.amostra.terceiro.st_classe')) 
            ) { 
                return link;
            }

            if ( !laudo.atendimento_procedimento.atendimento.id_medico_solicitante ) { 
                return link;
            }

            let id_ms = this.$store.state.user.st_tipo == 'R' 
                ? this.$store.state.user.id_medico_solicitante 
                : ( id_medico_solicitante ? id_medico_solicitante : laudo.atendimento_procedimento.atendimento.id_medico_solicitante );

            let ms = this.lista_medicos(laudo).find(item => item.id_medico_solicitante == id_ms);

            return link + ( link.indexOf('?') > 0 ? '&' : '?' ) 
                + 'ms=' + id_ms
                + '&n=' + ( ms ? ms.st_numero_conselho : '' )
                + '&r=portal'
                + ( this.timbrado ? '&t=1' : '' );
        },

        nao_solicitado (laudo, id_medico_solicitante) { 
            if ( !id_medico_solicitante ) { 
                return true;
            }

            return _.get(laudo, 'atendimento_procedimento.js_solics.' + id_medico_solicitante);
        },

        lista_medicos (item) { 
            if ( !item.atendimento_procedimento.atendimento.id_medico_solicitante ) { 
                return [];
            }

            let lista = [item.atendimento_procedimento.atendimento.medico_solicitante];

            if ( item.atendimento_procedimento.atendimento.solicitante_outros ) { 
                lista = lista.concat(item.atendimento_procedimento.atendimento.solicitante_outros.map(item => item.medico_solicitante));
            }

            return lista;
        },

        tem_laudo_pronto(lista) { 
            return lista.find(item => item && item.status_laudo && item.status_laudo.fl_pronto) ? true : false;
        },

        sigla(item) { 
            return item.atendimento_procedimento.procedimento.st_sigla 
                ? item.atendimento_procedimento.procedimento.st_sigla 
                : item.atendimento_procedimento.procedimento.st_procedimento;
        },

        prazo(lista) { 
            return _.get(
                _.maxBy(lista.filter(item => item.status_laudo && !item.status_laudo.fl_nao_coletar && item.status_laudo.st_acao_especial != 'N'), 'atendimento_procedimento.dt_entrega'),
                'atendimento_procedimento.dt_entrega'
            );
        },

        is_lab(item) { 
            return item.atendimento_procedimento.procedimento.id_especialidade == 2
                || item.atendimento_procedimento.procedimento.id_especialidade == 67;
        },

        imprimir(laudo) { 
            if ( laudo.link ) { 
                this.abrir_laudo_link(laudo);
            } else { 
                this.$util.print_preview('imprimir/laudo/' + laudo.id_laudo, true);
            }
        },

        imprimir_lab(laudo) { 
            this.$util.print_preview('imprimir/laudo_lab/' + laudo.atendimento_procedimento.id_atendimento, true);
        },

        dados_procedimento(laudo) { 
            return { 
                marcacao: { 
                    procedimento: laudo.atendimento_procedimento.procedimento,
                    medico: laudo.atendimento_procedimento.atendimento.medico, 
                    arquivos: laudo.atendimento_procedimento.atendimento.marcacao ? laudo.atendimento_procedimento.atendimento.marcacao.arquivos : [],
                    doc_pre_atends: laudo.atendimento_procedimento.atendimento.marcacao ? laudo.atendimento_procedimento.atendimento.marcacao.doc_pre_atends : [], 
                    unidade_operacao: laudo.atendimento_procedimento.atendimento.marcacao ? laudo.atendimento_procedimento.atendimento.marcacao.unidade_operacao : null, 
                }
            };
        },

        load() { 

            this.laudos = [];

            if ( this.canceltoken ) {
                this.canceltoken.cancel('#BC#');
            }

            this.canceltoken = this.axios.CancelToken.source();

            this.$util.load(this, { 
                service: 'laudos',
                func: 'entrega',
                redir_api: true, 
                parms: { 
                    id_paciente: this.id_paciente ? this.id_paciente : this.$store.state.user.id_pessoa, 
                    portal: true, 
                },
                canceltoken: this.canceltoken.token,
                loadTo: res => { 
                    if ( res && res.sem_imagens ) {
                        this.sem_imagens = true; 
                    }                   

                    res.laudos.forEach(laudo => {
                        laudo.exibir_detalhes = false; 
                        laudo.primeiros = true; 

                        if ( this.$store.state.user.st_tipo == 'R' && laudo.atendimento_procedimento && laudo.atendimento_procedimento.atendimento ) { 
                            laudo.atendimento_procedimento.atendimento.id_medico_solicitante = this.$store.state.user.id_medico_solicitante;
                        }

                        if ( laudo.atendimento_procedimento && laudo.atendimento_procedimento.procedimento && laudo.atendimento_procedimento.procedimento.id_especialidade == 2 ) {
                            if ( !laudo.status_laudo ) { 
                                laudo.status_laudo = { 
                                    st_color: 'secondary', 
                                    search: '-', 
                                };
                            } else if ( laudo.status_laudo.fl_pronto ) { 
                                laudo.status_laudo.st_color = 'success'; 
                                //laudo.status_laudo.search = 'Disponível';
                            } else if ( laudo.status_laudo.fl_nao_coletar ) { 
                                laudo.status_laudo.st_color = 'danger'; 
                                //laudo.status_laudo.search = 'Material Pendente';
                            } else if ( laudo.status_laudo.st_acao_especial == 'N' ) { 
                                laudo.status_laudo.st_color = 'warning'; 
                                //laudo.status_laudo.search = 'Material Pendente';
                            } else { 
                                laudo.status_laudo.st_color = 'primary'; 
                                laudo.status_laudo.search = 'Em execução';
                            }
                        }
                    });

                    this.laudos = res.laudos;
                    this.consultas = res.consultas;
                    this.pagpend = res.pagpend;
                    this.pagpend_lista = res.pagpend_lista;
                    this.legado = res.legado;
                    this.nps_avaliar = res.nps_avaliar;
                    this.limp = res.limp; 
                    this.msg_resultado = res.msg_resultado ? res.msg_resultado : null;

                    if ( res.config && res.config.portal_resultados_abertos ) { 
                        this.portal_resultados_abertos = true; 
                    }
                }
            });

        }
    },

    mounted() { 
        this.load();
    }
}
</script>
